<template>
  <div class="mainArea CProductAuth">
    <!-- 主要头部内容 -->
    <div class="mainHeadContent">
      <!-- 面包屑 -->
      <CBreadCrumb></CBreadCrumb>
    </div>
    <!--主内容区-->
    <div class="mainBodyContent">
      <!-- 搜索框 -->
      <div class="searchBox">
        <el-input class="w200" placeholder="请输入用户姓名" v-model="keyword.name" clearable @keyup.enter.native="ProductAuthList(1)"></el-input>
        <el-input class="w200" placeholder="请输入授权产品" v-model="keyword.product" clearable @keyup.enter.native="ProductAuthList(1)"></el-input>
        <el-select v-model="keyword.status" placeholder="请选择状态" clearable @change="ProductAuthList(1)">
          <el-option label="生效中" value="1"></el-option>
          <el-option label="已失效" value="2"></el-option>
          <el-option label="未生效" value="3"></el-option>
        </el-select>
        <el-button class="searchBtn" type="primary" @click="ProductAuthList(1)">搜 索</el-button>
      </div>
      <!-- 添加预约信息 -->
      <div class="addButton">
        <el-button type="primary" @click="openDio('add')">添加授权</el-button>
        <el-button type="warning" @click="openDelDio('batch')">批量取消</el-button>
      </div>
      
      <el-table v-loading="loading" :data="authData" style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" :selectable='checkboxT'></el-table-column>
        <el-table-column type="index" label="序号" width="80"></el-table-column>
        <el-table-column label="授权用户" prop="UserName" width="120"></el-table-column>
        <el-table-column label="授权产品" prop="ProductName" width="150"></el-table-column>
        <el-table-column label="授权时间">
          <template slot-scope="scope">
            <span v-if="scope.row.UseTimetype == 0">永久</span>
            <span v-else>{{scope.row.StartUsetime}}--{{scope.row.EndUsetime}}</span>
          </template>
        </el-table-column>
        <el-table-column label="添加时间" prop="CreateTime"></el-table-column>
        <el-table-column label="状态" width="80">
          <template slot-scope="scope">
            <span class="col67C" v-if="scope.row.Status == '1'">生效中</span>
            <span class="col999" v-else-if="scope.row.Status == '2'">已失效</span>
            <span v-else>未生效</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" v-if="scope.row.Status != '2'" @click="openDelDio('del',scope.row.Id)">取消授权</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="paging" v-if="total>limits">
        <el-pagination
          @current-change="CurrentChange"
          :current-page.sync="curr"
          :page-size="limits"
          layout="prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>

      <el-dialog :title="dioTitle" :visible.sync="wareDio" :width="dioWidth" class="configDio wareDio" center @close="closeDio">
        <div class="step">
          <div class="item" :class="{'activeStep' : dioform.Step == 1}">1、设置授权信息</div>
          <div class="item" :class="{'activeStep' : dioform.Step == 2}">2、选择授权产品</div>
        </div>
        <template v-if="dioform.Step == 1">
        <div class="contDio">
          <el-form :model="dioform" :rules="rules" label-position="top" label-width="90px">
            <el-form-item label="授权时间" prop="timeType">
              <el-select v-model="dioform.timeType" class="w100">
                <el-option label="指定时间" value="1"></el-option>
                <el-option label="永久" value="0"></el-option>
              </el-select>
              <el-date-picker
                v-model="dioform.time"
                type="daterange"
                range-separator="至"
                value-format="yyyy-MM-dd"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                v-if="dioform.timeType == '1'">
              </el-date-picker>

            </el-form-item>
          </el-form>
          <div class="tit flex">
            <div>授权用户:</div>
            <div class="col6">已勾选：{{dioform.userInfo.length}}人</div>
          </div>
          <!--调用用户选择组件-->
          <authUserComp @CheckUserInfo="CheckUserInfo" v-if="wareDio" :isRadio="false"></authUserComp>
        </div>
        <span slot="footer">
          <el-button @click="closeDio">取消</el-button>
          <el-button type="primary" @click="nextStep">下一步</el-button>
        </span>
        </template>
        <template v-else-if="dioform.Step == 2">
        <div class="contDio">
          <div class="searchDio">
            <el-input v-model="dioform.keyName" placeholder="请输入产品编号或产品名称" class="w200" @keyup.enter.native="ProductBomList(1)"></el-input>
            <el-input v-model="dioform.keyRfid" placeholder="请输入RFID编号" class="w200" @keyup.enter.native="ProductBomList(1)"></el-input>
            <el-button type="primary" @click="ProductBomList(1)">搜索</el-button>
          </div>
          <el-table :data="dioform.productList" style="width:100%" height="350px" @selection-change="productSelectionChange">
            <el-table-column type="selection"></el-table-column>
            <el-table-column label="序号" type="index"></el-table-column>
            <el-table-column label="产品编号" prop="ProductSn"></el-table-column>
            <el-table-column label="产品名称" prop="ProductName"></el-table-column>
            <el-table-column label="限制货架" prop="RackName"></el-table-column>
            <el-table-column label="限制货位" prop="ZhyName"></el-table-column>
            <el-table-column label="RFID编号" prop="Rfid" fixed="right"></el-table-column>
          </el-table>
          <div class="paging" v-if="totalDio>limitsDio">
            <el-pagination
              @current-change="CurrentChangeDio"
              :current-page.sync="currDio"
              :page-size="limitsDio"
              layout="prev, pager, next, jumper"
              :total="totalDio">
            </el-pagination>
          </div>
        </div>
        <span slot="footer">
          <el-button @click="prevStep">上一步</el-button>
          <el-button type="primary" @click="AddProductAuth">确定</el-button>
        </span>
        </template>
      </el-dialog>

    </div>
  </div>
</template>
<script>
  import CBreadCrumb from "../../Layout/CBreadCrumb.vue"
  import { showToast,updataBreadCrumb } from "../../../../../static/js/utility/utility.js"
  import { userApi,authApi,bussinessApi } from '../../../../../static/js/api'
  import authUserComp from '../../../../assets/authUser'
  var vm
  export default {
    name: 'CProductAuth',
    components: {
      CBreadCrumb,
      authUserComp
    },
    data() {
      return {
        //搜索
        keyword:{
          name:'',//姓名
          product:'',//授权产品
          status:'',//状态
        },

        loading:false,
        authData:[],//授权产品数据

        checkTab:[],//勾选中当前授权

        //分页
        curr:1,
        limits:10,
        total:0,

        dioTitle:'',
        wareDio:false,//弹窗
        dioTitle:'',//弹窗标题
        dioWidth:'',//弹窗的宽度
        dioType:'',//弹窗的类型
        dioform:{
          Id:'',
          Step:1,//步骤
          timeType:'1',//时间类型
          time:'',
          userInfo:'',
          keyName:'',
          keyRfid:'',
          productList:[],//产品数据
          checkProduct:[],
        },

        currDio:1,
        limitsDio:10,
        totalDio:0,

        rules:{
          timeType:[
            { required: true, message: '请选择时间类型', trigger: 'blur' },
          ],
        },

        
      }
    },
    async created(){
      vm = this
      vm.ProductAuthList()
    },
    methods:{
      //打开取消授权
      openDelDio(type,Id){
        vm.$confirm('是否取消授权', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if(Id){
            vm.dioform.Id = Id.toString()
          }
          vm.DelProductAuth(type)
        }).catch(() => {});
      },
      //取消产品授权
      async DelProductAuth(type){
        console.log(typeof vm.dioform.Id)
        const dataObj = {
          'Id': type == 'batch' ? vm.checkTab : vm.dioform.Id.split(','),//用户ID
        }
        const res = await bussinessApi.DelProductAuth(dataObj)
        if(res){
          if(res.ErrCode == 0 ){
            showToast('取消授权成功！')
            vm.ProductAuthList(1)
            vm.closeDio()
          }else{
            showToast(res.ErrMsg)
          }
        }
      },
      //添加产品授权
      async AddProductAuth(){
        const dataObj = {
          'UserId': vm.dioform.userInfo,//用户ID
          'UseTimetype': vm.dioform.timeType,//时间类型：0永久 1指定时间
          'StartTime': vm.dioform.timeType == 1 && vm.dioform.time !='' ? vm.dioform.time[0]:'',//开始时间
          'EndTime': vm.dioform.timeType == 1 && vm.dioform.time !='' ? vm.dioform.time[1]:'',//结束时间
          'ProductSn': vm.dioform.checkProduct,//产品编号
        }
        const res = await bussinessApi.AddProductAuth(dataObj)
        if(res){
          if(res.ErrCode == 0 ){
            showToast('添加成功！')
            vm.ProductAuthList(1)
            vm.closeDio()
          }else{
            showToast(res.ErrMsg)
          }
        }
      },
      //获取初始化产品列表
      async ProductBomList(curr,limits){
        let data = {
          'Product': vm.dioform.keyName,
          'Rfid': vm.dioform.keyRfid,
          'Curr': curr ? curr : vm.currDio,
          'Limits': limits ? limits : vm.limitsDio,
        }
        const res = await bussinessApi.ProductBomList(data)
        if(res){
          if(res.ErrCode == 0 ){
            if(res.Result){
              vm.dioform.productList = res.Result.List
              vm.currDio = parseInt(res.Result.Curr)
              vm.totalDio = parseInt(res.Result.Total)
            }
          }else{
            showToast(res.ErrMsg)
          }
        }
      },
      CurrentChangeDio(val){
        vm.currDio = val
        vm.ProductBomList(val)
      },
      //产品选中
      productSelectionChange(val){
        var arr = []
        for(var i in val){
          arr.push(val[i].ProductSn)
        }
        this.dioform.checkProduct = arr
      },
      //上一步
      prevStep(){
        vm.dioform.Step = 1
      },
      //下一步
      nextStep(){
        if(vm.dioform.timeType == '1'){
          if(vm.dioform.time == '') {
            showToast('请选择时间段')
            return
          }
        }
        if(vm.dioform.userInfo==''){
          showToast('请选择授权用户')
          return
        }
        vm.dioform.Step = 2
      },
      //打开弹窗
      openDio(type){
        if(type == 'add'){
          vm.dioTitle='添加授权'
          vm.dioWidth = '800px'
          vm.ProductBomList(1)
        }
        vm.wareDio = true
      },
      //关闭弹窗
      closeDio(){
        vm.dioform={
          Id:'',
          Step:'1',//步骤
          timeType:'1',//时间类型
          time:'',
          userInfo:'',
          keyName:'',
          keyRfid:'',
          productList:[],//产品数据
          checkProduct:[]
        }
        vm.wareDio = false
      },

      //设置表格多选框是否可选
      checkboxT(row,index){
        // console.log('tag', row)
        // 只有已生效和未生效的可勾选，已失效的不可勾选
    		if(row.Status !='2'){
    			return true
    		}else{
    			return false
    		}
    	},
      //获取table选中
      handleSelectionChange(val) {
        var arr = []
        for(var i in val){
          arr.push(val[i].Id)
        }
        this.checkTab = arr;
      },

      //获取产品授权列表
      async ProductAuthList(curr,limits){
        const dataObj = {
          'UserName':vm.keyword.name,//用户名
          'ProductName':vm.keyword.product,//产品名称
          'Status':vm.keyword.status,//状态，1生效 2失效 3未到使用时间
          'Curr': curr ? curr : vm.curr,
          'Limits': limits ? limits : vm.limits
        }
        const res = await bussinessApi.ProductAuthList(dataObj)
        if(res){
          if(res.ErrCode == 0 ){
            if(res.Result){
            vm.authData = res.Result.List
            vm.curr = parseInt(res.Result.Curr)
            vm.total = parseInt(res.Result.Total)
            }
          }else{
            showToast(res.ErrMsg)
          }
        }
      },
      //分页
      CurrentChange(val){
        this.curr = val
        //执行列表方法
        vm.ProductAuthList(val)
      },

      //获取授权的勾选用户
      CheckUserInfo(data){
        vm.dioform.userInfo = data
      },
    },
    watch:{

    }
  }
</script>
<style lang="scss">
.CProductAuth{
  .w200{
    width: 200px;
  }
  .col67C{
    color: #67C23A;
  }
  .col999{
    color: #999;
  }
  .searchBox {
    margin-bottom: 20px;
  }
  .wareDio{
    .step{
      padding: 0;
      height: 30px;
      margin: 0 33px 10px 18px;
      background: #DADADA;
      border-radius: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      .item{
        width: 50%;
        font-size: 12px;
        color: #fff;
        line-height: 30px;
        text-align: center;
        position: relative;
        &::after{
          content: "";
          position: absolute;
          right: -30px;
          top: 0;
          width: 0;
          height: 0;
          border-width: 15px;
          border-style: solid;
          border-color: transparent transparent transparent #DADADA;
          z-index: 10;
        }
        &.activeStep{
          background: #4BABFE;
          &::after{
            border-color: transparent transparent transparent #4BABFE;
          }
        }
      }
    }
    .flex{
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .tit{
      padding-left: 10px;
      padding-bottom: 10px;
      font-size: 14px;
      color: #333;
    }
    .contDio{
      .paging{
        margin: 20px 0 0;
      }
      .el-form-item{
        .el-form-item__label{
          padding: 0;
        }
      }
    }
    
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Page/CStorage/CProductAuth/CProductAuth.vue